// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2mU4T","right":"styles_right__2F0j5"};